const initialState = {
  loading: false,
  courses: [],
  message: {
    success: null,
    error: null,
  },
  singleCourse: {},
};

const CourseReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCHING_COURSE":
      return {
        ...state,
        loading: true,
      };

    case "FETCH_COURSE_SUCCESS":
      return {
        ...state,
        loading: false,
        courses: payload,
        message: {
          success: "Courses has been fetched successfully",
          error: null,
        },
      };

    case "FETCHING_COURSE_ERROR":
      return {
        ...state,
        loading: false,
        message: {
          success: null,
          error: "Failed to fetch course",
        },
      };

    case "FETCHING_SINGLE_COURSE":
      return {
        ...state,
        loading: true,
      };

    case "FETCH_SINGLE_COURSE_SUCCESS":
      return {
        ...state,
        message: {
          success: "Course has been fetched successfully",
          error: null,
        },
        singleCourse: payload,
        loading: false,
      };

    case "FETCHING_SINGLE_COURSE_ERROR":
      return {
        ...state,
        loading: false,
        message: {
          success: null,
          error: "Failed to fetch course",
        },
      };

    default:
      return state;
  }
};

export default CourseReducer;
